import { render, staticRenderFns } from "./AdminComment.vue?vue&type=template&id=530a3692&scoped=true"
import script from "./AdminComment.vue?vue&type=script&lang=js"
export * from "./AdminComment.vue?vue&type=script&lang=js"
import style0 from "./AdminComment.vue?vue&type=style&index=0&id=530a3692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530a3692",
  null
  
)

export default component.exports